import { render, staticRenderFns } from "./updateguestalert.vue?vue&type=template&id=1199b05c&"
import script from "./updateguestalert.vue?vue&type=script&lang=js&"
export * from "./updateguestalert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports